<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageUsers.title') }}
    </portal>
    <template v-if="users !== null">
      <card :title="$t('admin.pageUsers.card.users')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <template v-for="user in users" v-if="!user.deleted">
              <hm-card-inner-line :title="getName(user)" :clickable="true" :key="user.id" @click="routeToUser(user)" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedUsers) && hasRole('ROLE_SYSADMIN')" :title="$t('admin.pageUsers.card.deletedUsers')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="user in deletedUsers"
                              :title="getName(user)"
                              :clickable="true"
                              :key="user.id"
                              @click="routeToUser(user)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageUsers.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageUsers.actions.addUser')" icon="plus" color="blue" @click="addUser()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageUsers',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      users: null,
    };
  },

  computed: {
    deletedUsers: function () {
      return isNil(this.users) ? null : this.users.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.user.list(this))
        .then((response) => {
          this.users = response.data.data;

          this.$serviceBus.$emit('user.list', this.users);
        });
    },
    addUser() {
      this.axios.post(this.serviceUrls.user.list(this), {
        userName: `${this.$t('admin.pageUsers.newUserName')}${Math.round(Math.random() * 255, 0)}`,
        roles: ['ROLE_USER'],
        enabled: false,
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(user) {
      const name = isNil(user) ? null : user.userName;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name;

      let details = '';

      if (user.deleted === false) {
        if (user.enabled === false) {
          details += `, ${this.$t('admin.pageUsers.userDisabled')}`;
        }
      }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeToUser(user) {
      this.$router.push({
        name: 'user',
        params: {
          userId: user.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageUsers.vue